import { PressCards } from '../../components/PressCards';
import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './HumanitiesNewsSection.module.css';

export function HumanitiesNewsSection() {
  return (
    <SectionWrapper background="soft" data-testid="humanities-section-news">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>IN THE NEWS</p>
          <h2 className={styles.title}>In the news</h2>
          <p className={styles.body}>
            Kudu Humanities and its collaborators have been featured in discussions
            of innovative approaches to artificial intelligence and higher
            education — highlighting the growing role of human-centered AI in
            transforming teaching and learning.
          </p>
        </div>

        <PressCards />
      </div>
    </SectionWrapper>
  );
}
